import { render } from "./DeleteItemModal.vue?vue&type=template&id=2c67f1ae"
import script from "./DeleteItemModal.vue?vue&type=script&lang=js"
export * from "./DeleteItemModal.vue?vue&type=script&lang=js"

import "./DeleteItemModal.vue?vue&type=style&index=0&id=2c67f1ae&lang=scss"

import exportComponent from "/var/www/nexgen/apps/admin/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__